import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import "../../CSS/carta.css";
import { URIMG } from '../../Conexiones/Conexion';

function CarObra({titulo,imagen,direccion,id,proyectoNull}) {
    const navigate = useNavigate()
    const select = (id) => {
        sessionStorage.setItem("obra", id)
        sessionStorage.setItem("proyectoNull", proyectoNull)
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras')
    }
    return (
        <div>
            <div className="card2" style={{marginTop:"10px"}}>
                < img className="card__image"  type="button" id={id} onClick={() => select(id)} 
                    src={URIMG + imagen} as={Link} to={direccion} alt=""/>
                <div className="card__overlay" style={{backgroundColor:"#2DBAFF"}}>
                    <div className="card__header" style={{backgroundColor:"#2DBAFF"}}>
                        <svg className="card__arc" xmlns="http://www.w3.org/2000/svg">{/*<path style={{fill:"#2DBAFF"}} />*/}</svg>                     
                        <div className="card__header-text" style={{marginBottom:"30px"}}>
                            <h3 className="card__title" >{titulo}</h3>            
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default CarObra;